import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthService } from '@psu-pennstateit-swe/utils/security';

export const authGuard: CanMatchFn = () => {
  const currentUser = inject(AuthService).getCurrentUser();
  const router = inject(Router);

  if (currentUser) {
    return true;
  }

  return router.parseUrl('/forbidden');
};
